
import { Component, Prop, Vue } from "vue-property-decorator";

type InteractiveGiftCardOption = {
  value: string | number;
  title: string;
  description: string;
  icon: string;
  disabled?: boolean;
};

type InteractiveGiftCardGift = {
  kind: string;
};

type InteractiveGiftCardReveal = {
  title: string;
  description: string;
  icon: string;
};

@Component
export default class InteractiveGiftCard extends Vue {
  @Prop({ required: true }) gift!: InteractiveGiftCardGift;
  @Prop({ required: true }) revealedGift!: InteractiveGiftCardReveal;
  @Prop({ default: false }) isUnboxed!: boolean;
  @Prop({ default: false }) isRevealed!: boolean;
  @Prop({ default: false }) showAddonChoice!: boolean;
  @Prop({ default: "" }) closedLabel!: string;
  @Prop({ default: "" }) addonTitle!: string;
  @Prop({ default: "" }) chooseAddonLabel!: string;
  @Prop({ default: "" }) addonPopoverTitle!: string;
  @Prop({ default: (): InteractiveGiftCardOption[] => [] }) addonOptions!: InteractiveGiftCardOption[];
}
